import get from 'lodash.get';
import getSiteData from './site-data';

const getSiteLocale = (rootState) => {
  const siteData = getSiteData(rootState);
  return get(siteData, 'locale', null);
};

export default getSiteLocale;
